const STORAGE_KEY = 'bandi_store_id';

export const DEFAULT_STORE_ID = process.env.REACT_APP_STORE_ID || '8ed456a45bc7321f114a0029c7';

// Odkaz z prodejny nese store_id v URL uvodni stranky - ulozime ho pro registraci.
export const captureStoreId = (search) => {
  const storeId = new URLSearchParams(search).get('storeid')?.trim();

  if (!storeId) return;

  try {
    sessionStorage.setItem(STORAGE_KEY, storeId);
  } catch {
    // sessionStorage nemusi byt dostupny - registrace pobezi s vychozim store_id.
  }
};

// Ulozene store_id z uvodni adresy, jinak vychozi z konfigurace.
export const getStoreId = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || DEFAULT_STORE_ID;
  } catch {
    return DEFAULT_STORE_ID;
  }
};
